import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductTypeCustomProductSpec } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeCustomProductSpecService extends TmsWebBaseEditCreateService<
  ProductTypeCustomProductSpec,
  ProductTypeCustomProductSpec
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductTypeCustomProductSpec', $localize`Product Type Custom Product Spec`);
  }

  getForProductType(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductTypeCustomProductSpec/${id}`);
  }

  getForProductTypeAndCustomProductSpecHeader(
    productTypeId: string,
    customProductSpecHeader: string,
  ): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(
      `${this.apiUrl}/GetForProductTypeAndCustomProductSpecHeader?productTypeId=${productTypeId}&customProductSpecHeader=${customProductSpecHeader}`,
    );
  }

  getAllCustomProductSpecDetailsForProductTypes(productTypeId: string): Observable<ProductTypeCustomProductSpec[]> {
    return this.httpService.get<ProductTypeCustomProductSpec[]>(
      `${this.apiUrl}/GetAllCustomProductSpecs?ProductTypeId=${productTypeId}`,
    );
  }

  getAllCustomProductSpecHeadersForProductType(productType: string): Observable<ProductTypeCustomProductSpec[]> {
    return this.httpService.get<ProductTypeCustomProductSpec[]>(
      `${this.apiUrl}/GetAllCustomProductSpecHeaders?productType=${productType}`,
    );
  }

  updateCustomProductSpecHeadersProductTypes(
    productTypeId: string,
    CustomProductSpecHeaderIds: string[],
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateCustomProductSpecProductTypes`, {
      productTypeId,
      CustomProductSpecHeaderIds,
    });
  }
}
